import { throwException, blobToText } from '../common';
import type { ListPaginatedDTO } from '@pct-sdk/core';
import type { HttpContext } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import type {
  AdminNewsGetDTO,
  AdminNewsListDTO,
  AdminNewsOrderByColumn,
  AdminNewsPostPutDTO,
  LanguageCode,
  OrderByDirection,
  PaginatedDTOOfAdminNewsListDTO,
  StatusCode,
} from '../dto/dto';

import { environment } from '@szte-griffin/environment';
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
// ReSharper disable InconsistentNaming
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import type { Observable } from 'rxjs';
import { throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject } from '@angular/core';

/* eslint-disable */
@Injectable()
export class AdminNewsService {
  private http: HttpClient;
  private readonly baseUrl = environment.apiUrl;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  constructor(
    @Inject(HttpClient)
    http: HttpClient,
  ) {
    this.http = http;
  }
  /**
   * @param ids (optional)
   * @param categoryIds (optional)
   * @param statuses (optional)
   * @param isHighlighted (optional)
   * @param language (optional)
   * @param searchText (optional)
   * @param publishedFrom (optional)
   * @param publishedTo (optional)
   * @param orderColumn (optional)
   * @param orderDirection (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  public listAdminNews(
    ids?: string[] | undefined,
    categoryIds?: string[] | undefined,
    statuses?: StatusCode[] | undefined,
    isHighlighted?: boolean | undefined,
    language?: LanguageCode | undefined,
    searchText?: string | undefined,
    publishedFrom?: string | undefined,
    publishedTo?: string | undefined,
    orderColumn?: AdminNewsOrderByColumn | undefined,
    orderDirection?: OrderByDirection | undefined,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    httpContext?: HttpContext,
  ): Observable<ListPaginatedDTO<AdminNewsListDTO>> {
    let url_ = this.baseUrl + '/admin/news?';
    if (ids === null) throw new Error("The parameter 'ids' cannot be null.");
    else if (ids !== undefined)
      ids &&
        ids.forEach(item => {
          url_ += 'ids=' + encodeURIComponent('' + item) + '&';
        });
    if (categoryIds === null) throw new Error("The parameter 'categoryIds' cannot be null.");
    else if (categoryIds !== undefined)
      categoryIds &&
        categoryIds.forEach(item => {
          url_ += 'categoryIds=' + encodeURIComponent('' + item) + '&';
        });
    if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
    else if (statuses !== undefined)
      statuses &&
        statuses.forEach(item => {
          url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
        });
    if (isHighlighted === null) throw new Error("The parameter 'isHighlighted' cannot be null.");
    else if (isHighlighted !== undefined)
      url_ += 'isHighlighted=' + encodeURIComponent('' + isHighlighted) + '&';
    if (language === null) throw new Error("The parameter 'language' cannot be null.");
    else if (language !== undefined) url_ += 'language=' + encodeURIComponent('' + language) + '&';
    if (searchText === null) throw new Error("The parameter 'searchText' cannot be null.");
    else if (searchText !== undefined)
      url_ += 'searchText=' + encodeURIComponent('' + searchText) + '&';
    if (publishedFrom === null) throw new Error("The parameter 'publishedFrom' cannot be null.");
    else if (publishedFrom !== undefined)
      url_ += 'publishedFrom=' + encodeURIComponent('' + publishedFrom) + '&';
    if (publishedTo === null) throw new Error("The parameter 'publishedTo' cannot be null.");
    else if (publishedTo !== undefined)
      url_ += 'publishedTo=' + encodeURIComponent('' + publishedTo) + '&';
    if (orderColumn === null) throw new Error("The parameter 'orderColumn' cannot be null.");
    else if (orderColumn !== undefined)
      url_ += 'orderColumn=' + encodeURIComponent('' + orderColumn) + '&';
    if (orderDirection === null) throw new Error("The parameter 'orderDirection' cannot be null.");
    else if (orderDirection !== undefined)
      url_ += 'orderDirection=' + encodeURIComponent('' + orderDirection) + '&';
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');
    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
      context: httpContext,
    };
    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListAdminNews(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListAdminNews(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PaginatedDTOOfAdminNewsListDTO>;
            }
          } else
            return _observableThrow(response_) as any as Observable<PaginatedDTOOfAdminNewsListDTO>;
        }),
      );
  }
  protected processListAdminNews(
    response: HttpResponseBase,
  ): Observable<ListPaginatedDTO<AdminNewsListDTO>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver,
                ) as PaginatedDTOOfAdminNewsListDTO);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>OUT_OF_RANGE_PAGE_SIZE - The page size must be more than zero.</li><li>TOO_LONG_SEARCH_TEXT - The search text is too long.</li><li>TOO_SMALL_PAGE_NUMBER - The page number must be more than zero.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>INVALID_INTERVAL - The given time interval is not valid.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @param body (optional)
   * @return Created
   */
  public createNews(
    body?: AdminNewsPostPutDTO | undefined,
    httpContext?: HttpContext,
  ): Observable<AdminNewsGetDTO> {
    let url_ = this.baseUrl + '/admin/news';
    url_ = url_.replace(/[?&]$/, '');
    const content_ = JSON.stringify(body);
    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
      context: httpContext,
    };
    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateNews(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateNews(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AdminNewsGetDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<AdminNewsGetDTO>;
        }),
      );
  }
  protected processCreateNews(response: HttpResponseBase): Observable<AdminNewsGetDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          result201 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AdminNewsGetDTO);
          return _observableOf(result201);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>CONTENT_AND_IMAGE_LANGUAGE_DOES_NOT_MATCH - The contents and images language are not match.</li><li>DUPLICATE_IMAGES_NOT_ALLOWED - Duplicate images are not allowed.</li><li>INVALID_DATE - Date is invalid.</li><li>INVALID_INTERVAL - The given time interval is not valid.</li><li>REQUIRED_CONTENT - The content is mandatory.</li><li>REQUIRED_COVER_IMAGE - Cover image required.</li><li>REQUIRED_COVER_IMAGE_SUBTITLE - Required cover image subtitle.</li><li>REQUIRED_CTA_FIELDS - Both CTA fields are mandatory when one of them is provided.</li><li>REQUIRED_DESCRIPTION - The description is mandatory.</li><li>REQUIRED_IMAGE_SUBTITLE - Image subtitle is required.</li><li>REQUIRED_TITLE - The title is mandatory.</li><li>TOO_FEW_CATEGORIES - At least one category must be provided.</li><li>TOO_FEW_IMAGE_TRANSLATIONS - Too few image translations.</li><li>TOO_FEW_NEWS_TRANSLATIONS - Too few news translations.</li><li>TOO_LONG_CONTENT_DESCRIPTION - The description must be at most 255 characters.</li><li>TOO_LONG_CONTENT_TITLE - The title must be at most 255 characters.</li><li>TOO_LONG_COVER_IMAGE_SUBTITLE - The cover image subtitle is too long.</li><li>TOO_LONG_IMAGE_SUBTITLE - The image subtitle is too long.</li><li>TOO_LONG_LABEL_NAME - The label name is too long.</li><li>TOO_LONG_URL - The url is too long.</li><li>TOO_MANY_IMAGES - Too many images.</li><li>TOO_MANY_SAME_TRANSLATION_LANGUAGE - Too many same translation language.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 422) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "<ul><li>NOT_FOUND_FILE - The file cannot be found.</li><li>NOT_FOUND_NEWS_CATEGORY - Can\'t find the news category.</li></ul>",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @return OK
   */
  public findAdminNews(id: string, httpContext?: HttpContext): Observable<AdminNewsGetDTO> {
    let url_ = this.baseUrl + '/admin/news/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
      context: httpContext,
    };
    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFindAdminNews(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFindAdminNews(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AdminNewsGetDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<AdminNewsGetDTO>;
        }),
      );
  }
  protected processFindAdminNews(response: HttpResponseBase): Observable<AdminNewsGetDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AdminNewsGetDTO);
          return _observableOf(result200);
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "<ul><li>NOT_FOUND_NEWS - Can\'t find any news.</li></ul>",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @param body (optional)
   * @return OK
   */
  public updateNews(
    id: string,
    body?: AdminNewsPostPutDTO | undefined,
    httpContext?: HttpContext,
  ): Observable<AdminNewsGetDTO> {
    let url_ = this.baseUrl + '/admin/news/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    const content_ = JSON.stringify(body);
    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
      context: httpContext,
    };
    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateNews(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateNews(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AdminNewsGetDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<AdminNewsGetDTO>;
        }),
      );
  }
  protected processUpdateNews(response: HttpResponseBase): Observable<AdminNewsGetDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AdminNewsGetDTO);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>CONTENT_AND_IMAGE_LANGUAGE_DOES_NOT_MATCH - The contents and images language are not match.</li><li>DUPLICATE_IMAGES_NOT_ALLOWED - Duplicate images are not allowed.</li><li>EXTERNAL_ENTITY - This entity is external.</li><li>INVALID_DATE - Date is invalid.</li><li>INVALID_INTERVAL - The given time interval is not valid.</li><li>REQUIRED_CONTENT - The content is mandatory.</li><li>REQUIRED_COVER_IMAGE - Cover image required.</li><li>REQUIRED_COVER_IMAGE_SUBTITLE - Required cover image subtitle.</li><li>REQUIRED_CTA_FIELDS - Both CTA fields are mandatory when one of them is provided.</li><li>REQUIRED_DESCRIPTION - The description is mandatory.</li><li>REQUIRED_IMAGE_SUBTITLE - Image subtitle is required.</li><li>REQUIRED_TITLE - The title is mandatory.</li><li>TOO_FEW_CATEGORIES - At least one category must be provided.</li><li>TOO_FEW_IMAGE_TRANSLATIONS - Too few image translations.</li><li>TOO_FEW_NEWS_TRANSLATIONS - Too few news translations.</li><li>TOO_LONG_CONTENT_DESCRIPTION - The description must be at most 255 characters.</li><li>TOO_LONG_CONTENT_TITLE - The title must be at most 255 characters.</li><li>TOO_LONG_COVER_IMAGE_SUBTITLE - The cover image subtitle is too long.</li><li>TOO_LONG_IMAGE_SUBTITLE - The image subtitle is too long.</li><li>TOO_LONG_LABEL_NAME - The label name is too long.</li><li>TOO_LONG_URL - The url is too long.</li><li>TOO_MANY_IMAGES - Too many images.</li><li>TOO_MANY_SAME_TRANSLATION_LANGUAGE - Too many same translation language.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "<ul><li>NOT_FOUND_NEWS - Can\'t find any news.</li></ul>",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 422) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "<ul><li>NOT_FOUND_FILE - The file cannot be found.</li><li>NOT_FOUND_NEWS_CATEGORY - Can\'t find the news category.</li></ul>",
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @return No Content
   */
  public deleteAdminNews(id: string, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/admin/news/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({}),
      context: httpContext,
    };
    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAdminNews(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteAdminNews(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }
  protected processDeleteAdminNews(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>EXTERNAL_ENTITY - This entity is external.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
